<template>
  <generic-modal :modal-key="'resubscribe_via_pin'" :has-extra-modal-class="'popup_box op_down modal_cont'"
                 @close="$emit('close')">
    <template slot="content">
      <h1>{{ getTranslations.home_modals_resubscribepin_you_are_close }}</h1>
      <img class="modal_icon_main" src="static/images/re_subscribe.png" alt="">
      <p>{{ getTranslations.home_modals_resubscribepin_we_sent }}</p>
      <form action="">
        <div class="form-group" :class="[ !hasErrors ? '' : 'has-warning' ]">
          <input type="text" class="form-group__textfield phone_input" :placeholder="getTranslations.home_modals_resubscribepin_enter_the" @keyup="check" v-model="pin"/>
          <span v-show="message && pin && hasErrors" class="form-group__feedback">{{ message }}</span>
        </div>
        <a @click.prevent="sendPin" id="submitBtn" style="cursor:pointer"
               class="ti_btn--main" :class="[ !hasErrors ? '' : 'deactivated' ]">{{ getTranslations.home_modals_resubscribepin_confirm }}</a>
      </form>
      <loading v-if="showLoadingModal"
               @close="showLoadingModal = false">
      </loading>
    </template>
  </generic-modal>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import IntegrationMixin from '../../../common/mixins/integration';
import loading from './Loading';
import modals from '../../../common/modals';
import WelcomeReturningUnsub from './WelcomeReturningUnsub';
import ResubscribeError from './../modals/store/ConfirmPurchaseForPinError';
import GenericModal from '../sharedcomponents/GenericModal';

export default {
  // modal_resubscribe_pin.html
  name: 'resubscribe-via-pin',
  mixins: [IntegrationMixin],
  data() {
    return {
      nextPage: '',
      pin: '',
      message: '',
      hasErrors: false,
      ti: null,
      ts: null,
      showLoadingModal: false,
    };
  },
  components: {
    GenericModal,
    WelcomeReturningUnsub,
    loading,
  },
  methods: {
    ...mapActions('profile', [
      'sendReOptinPin',
      'getUserLoginDetails',
    ]),
    ...mapMutations('common', [
      'storeModalForStore',
      'storeModalForHomePage',
    ]),
    check() {
      const validPinRegex = /^[0-9]{0,8}$/;
      const validPin = this.pin.match(validPinRegex);
      if (!validPin) {
        this.message = this.getTranslations.home_modals_resubscribepin_oops;
        this.hasErrors = true;
      } else {
        this.hasErrors = false;
        this.message = '';
      }
    },
    hasAsync() {
      const activeIntegration = this.getIntegrationByName();
      return !activeIntegration || activeIntegration.value.hasAsync;
    },
    showNextModal() {
      this.getUserLoginDetails().then(() => {
        if (sessionStorage.getItem('homeCurrentTabPath') === '/home' || sessionStorage.getItem('homeCurrentTabPath') === '/home/profile/edit') {
          this.storeModalForHomePage(WelcomeReturningUnsub);
          modals.showHideModal(this);
        } else if (sessionStorage.getItem('homeCurrentTabPath') === '/home/store') {
          this.storeModalForStore(WelcomeReturningUnsub);
          modals.showHideModalInStore(this);
        }
      });
    },
    sendPin() {
      // eslint-disable-next-line
      console.log('Send Pin Method');
      this.message = '';
      if (this.pin.length >= 4 && this.pin.length <= 8 && !this.hasErrors) {
        // eslint-disable-next-line
        console.log('Send Pin for Resubscribe user Call in 2 step');
        const pinParam = {
          pin: this.pin,
        };
        if (this.integrationHeader === this.availableIntegrations.OOREDOO_QATAR.name) {
          this.$axios.get(`api/verifyPin?msisdn=${this.userDetails.msisdn}&pin=${this.pin}&clickid=${this.getClickId}&refUrl=${this.getRefUrl}&campaignId=${this.getCampaignId}&publisherId=${this.getPublisherId}&ti=&ts=`).then((response) => {
            const resp = response.data.responseEnum;
            if (resp === 'OPERATION_SUCCESS') {
              this.hasErrors = false;
              this.showNextModal();
            } else if (resp === 'WRONG_PIN') {
              this.hasErrors = true;
              this.message = this.getTranslations.home_modals_resubscribepin_oops;
            } else if (resp === 'SERVER_ERROR') {
              if (sessionStorage.getItem('homeCurrentTabPath') === '/home/store') {
                this.storeModalForStore(ResubscribeError);
                modals.showHideModalInStore(this);
              } else {
                this.storeModalForHomePage(ResubscribeError);
                modals.showHideModal(this);
              }
            }
          });
        } else {
          this.sendReOptinPin({ pinObject: pinParam }).then(() => {
            // eslint-disable-next-line
            console.log('Resubscribe user Call in 2 step Reoptin');
            if (this.twoStepVerificationVerified) {
              if (this.integrationHeader === this.availableIntegrations.JAWWAL_PALESTINE.name) { // remove the available integration for Jawwal(to do) and use hasAsync only ... remove forResub parameter etc
                this.showLoadingModal = true;
                this.hasErrors = false;
                this.$axios.get(`api/getStatus?msisdn=${this.userDetails.msisdn}&pin=${this.pin}&lang=${this.getLocale}&forResub=true`).then((res) => {
                  this.showLoadingModal = false;
                  if (res.data.responseEnum === 'OPERATION_SUCCESS' && res.data.data) {
                    this.showNextModal();
                  }
                });
              } else if (this.hasAsync()) {
                this.showLoadingModal = true;
                this.hasErrors = false;
                this.$axios.get(`api/getStatus?msisdn=${this.userDetails.msisdn}&pin=${this.pin}&lang=${this.getLocale}&reSub=true`).then((res) => {
                  this.showLoadingModal = false;
                  if (res.data.responseEnum === 'OPERATION_SUCCESS' && res.data.data) {
                    this.showNextModal();
                  } else if (res.data.responseEnum === 'OPERATION_SUCCESS') {
                    this.showNextModal();
                  }
                });
              } else {
                this.hasErrors = false;
                this.showNextModal();
              }
            } else if (this.twoStepVerificationWrongPin) {
              this.hasErrors = true;
              this.message = this.getTranslations.home_modals_resubscribepin_oops;
            } else if (this.twoStepVerificationServerError) {
              if (sessionStorage.getItem('homeCurrentTabPath') === '/home/store') {
                this.storeModalForStore(ResubscribeError);
                modals.showHideModalInStore(this);
              } else {
                this.storeModalForHomePage(ResubscribeError);
                modals.showHideModal(this);
              }
            }
          });
        }
      } else {
        this.message = this.getTranslations.home_modals_resubscribepin_oops;
        this.hasErrors = true;
      }
    },
  },
  computed: {
    ...mapState('common', [
      'integrationHeader',
      'availableIntegrations',
    ]),
    ...mapState('profile', [
      'twoStepVerificationVerified',
      'twoStepVerificationWrongPin',
      'twoStepVerificationServerError',
      'twoStepVerificationBlockedUser',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/modals/ResubscribeViaPin.vue